import { jsPDF } from "jspdf";

// Paper sizes in millimetres. F4 = Indonesian folio 8.5 x 13 inch.
export const PAPER = {
  A4: { w: 210, h: 297, label: "A4" },
  F4: { w: 215.9, h: 330.2, label: "F4 (8.5 x 13\")" },
};

export function paperDims(size, orientation) {
  const p = PAPER[size] || PAPER.A4;
  return orientation === "landscape" ? { w: p.h, h: p.w } : { w: p.w, h: p.h };
}

// Build a single multi-page PDF, each page fitted (contain, centered) to the chosen size.
export function buildPdf(pages, size, orientation) {
  const { w, h } = paperDims(size, orientation);
  const orient = orientation === "landscape" ? "l" : "p";
  const pdf = new jsPDF({ orientation: orient, unit: "mm", format: [w, h], compress: false });
  pages.forEach((pg, idx) => {
    if (idx > 0) pdf.addPage([w, h], orient);
    const imgRatio = pg.width / pg.height;
    const pageRatio = w / h;
    let dw;
    let dh;
    if (imgRatio > pageRatio) {
      dw = w;
      dh = w / imgRatio;
    } else {
      dh = h;
      dw = h * imgRatio;
    }
    const x = (w - dw) / 2;
    const y = (h - dh) / 2;
    // Embed LOSSLESS (PNG, tanpa kompresi ulang) agar hasil tetap jernih seperti asli.
    pdf.addImage(pg.dataUrl, "PNG", x, y, dw, dh, undefined, "NONE");
  });
  return pdf.output("blob");
}

// Rotate a JPEG dataURL by +/-90 degrees. Returns { dataUrl, width, height }.
export function rotateDataUrl(dataUrl, deg) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const rad = (deg * Math.PI) / 180;
      const swap = Math.abs(deg) % 180 === 90;
      const c = document.createElement("canvas");
      c.width = swap ? img.height : img.width;
      c.height = swap ? img.width : img.height;
      const ctx = c.getContext("2d");
      ctx.translate(c.width / 2, c.height / 2);
      ctx.rotate(rad);
      ctx.drawImage(img, -img.width / 2, -img.height / 2);
      resolve({ dataUrl: c.toDataURL("image/png"), width: c.width, height: c.height });
    };
    img.src = dataUrl;
  });
}
